export const EXTENTIONS = {
  png: 'image/png',
  jpg: 'image/jpeg',
  pdf: 'application/pdf',
};
